import { G as push, Q as push_element, T as pop_element, O as attr, K as pop, F as FILENAME } from "../../../chunks/index.js";
_page[FILENAME] = "src/routes/categories/+page.svelte";
function _page($$payload, $$props) {
  push(_page);
  let newName = "";
  let newColor = "#3b82f6";
  $$payload.out.push(`<div class="p-4 space-y-6">`);
  push_element($$payload, "div", 13, 0);
  $$payload.out.push(`<header class="flex items-center gap-3">`);
  push_element($$payload, "header", 14, 2);
  $$payload.out.push(`<a href="/" class="text-blue-600 hover:underline">`);
  push_element($$payload, "a", 15, 4);
  $$payload.out.push(`← Tagasi tahvlile</a>`);
  pop_element();
  $$payload.out.push(` <h1 class="text-xl font-semibold">`);
  push_element($$payload, "h1", 16, 4);
  $$payload.out.push(`Kategooriate haldus</h1>`);
  pop_element();
  $$payload.out.push(`</header>`);
  pop_element();
  $$payload.out.push(` <section class="bg-white border rounded p-4 space-y-3">`);
  push_element($$payload, "section", 19, 2);
  $$payload.out.push(`<h2 class="font-medium">`);
  push_element($$payload, "h2", 20, 4);
  $$payload.out.push(`Lisa uus kategooria</h2>`);
  pop_element();
  $$payload.out.push(` <div class="flex flex-col md:flex-row gap-2 md:items-center">`);
  push_element($$payload, "div", 21, 4);
  $$payload.out.push(`<input placeholder="Nimi"${attr("value", newName)} class="border rounded px-3 py-2 w-full md:w-64"/>`);
  push_element($$payload, "input", 22, 6);
  pop_element();
  $$payload.out.push(` <div class="flex items-center gap-2">`);
  push_element($$payload, "div", 23, 6);
  $$payload.out.push(`<input type="color"${attr("value", newColor)} class="w-10 h-10 p-0 border rounded"/>`);
  push_element($$payload, "input", 24, 8);
  pop_element();
  $$payload.out.push(` <input class="border rounded px-3 py-2 w-36"${attr("value", newColor)}/>`);
  push_element($$payload, "input", 25, 8);
  pop_element();
  $$payload.out.push(`</div>`);
  pop_element();
  $$payload.out.push(` <button class="bg-blue-600 text-white px-3 py-2 rounded">`);
  push_element($$payload, "button", 27, 6);
  $$payload.out.push(`Lisa</button>`);
  pop_element();
  $$payload.out.push(`</div>`);
  pop_element();
  $$payload.out.push(`</section>`);
  pop_element();
  $$payload.out.push(` <section class="bg-white border rounded p-4">`);
  push_element($$payload, "section", 31, 2);
  $$payload.out.push(`<h2 class="font-medium mb-3">`);
  push_element($$payload, "h2", 32, 4);
  $$payload.out.push(`Olemasolevad kategooriad</h2>`);
  pop_element();
  $$payload.out.push(` `);
  {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div>`);
    push_element($$payload, "div", 34, 6);
    $$payload.out.push(`Laen…</div>`);
    pop_element();
  }
  $$payload.out.push(`<!--]--></section>`);
  pop_element();
  $$payload.out.push(`</div>`);
  pop_element();
  pop();
}
_page.render = function() {
  throw new Error("Component.render(...) is no longer valid in Svelte 5. See https://svelte.dev/docs/svelte/v5-migration-guide#Components-are-no-longer-classes for more information");
};
export {
  _page as default
};
